import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/cfc22774-7348-4e2b-9887-2157e1a17e16",
        "alt": "The FAQ component has a heading, optional subheading, and a list of questions that are interactive to expand and display answers"
      }}></img></p>
    <ul>
      <li parentName="ul">{`Heading: The main title of the FAQ.`}</li>
      <li parentName="ul">{`Subheading: An optional short description that extends the information provided by the heading and helps group the items in the list.`}</li>
      <li parentName="ul">{`Question: The question being answered.`}</li>
      <li parentName="ul">{`Answer: The answer to the question.`}</li>
    </ul>
    <h2>{`Usage`}</h2>
    <p>{`Use the FAQ to provide answers to common questions about a product or a feature presented on a page. The FAQ is a good way to provide additional information that may be beyond the scope of the main content of the page. We recommend placing the FAQ at the bottom of the page, after the main content. Avoid using the FAQ to provide information that is already available in the page.`}</p>
    <p>{`Answers should be clear and no longer than 2-3 paragraphs. If the answer is longer than the suggested, needs visual assets, or a specific layout treatment, consider using a different component. For instance, if the answer needs an image, we recommend using a list of `}<a parentName="p" {...{
        "href": "/components/Card"
      }}>{`cards`}</a>{` or a `}<a parentName="p" {...{
        "href": "/components/River"
      }}>{`river`}</a>{` component instead.`}</p>
    <p>{`For answers that need to provide a list of tasks, we recommend using an `}<a parentName="p" {...{
        "href": "/components/OrderedList"
      }}>{`ordered list`}</a>{`. To split the content into different items, we recommend using an `}<a parentName="p" {...{
        "href": "/components/UnorderedList"
      }}>{`unordered list`}</a>{`.`}</p>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/5566161b-439b-4e13-b41c-188723b0bae6" alt="" />
    <Caption mdxType="Caption">
      Use the FAQ to provide clear answers to common questions. Link to other
      resources and use ordered/unordered lists if necessary.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/a42230be-ee4b-4905-885b-dab98f4889c9" alt="" />
    <Caption mdxType="Caption">
      Don't use visual assets or other content-related components within the
      answers.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`FAQ group`}</h2>
    <p>{`When using long lists of questions and answers, consider using the FAQ group to organize items into content-related categories to make it easier for the user to scan the list.`}</p>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/a659524d-4574-4880-8f00-c6846438492e" alt="" />
    <Caption mdxType="Caption">Use the FAQ group for related questions and answers.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/315a9a4e-95de-4dc5-9129-ff31108d5dfd" alt="" />
    <Caption mdxType="Caption">
      Don't use long lists of questions and answers. We recommend using FAQ
      groups to group them and to help the user scan the list.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Card"
        }}>{`Card`}</a>{`: to display navigational related content with higher visual weight.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/River"
        }}>{`River`}</a>{`: To display a list of content items with a visual asset.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Pillar"
        }}>{`Pillar`}</a>{`: To display related content with less visual emphasis.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      